export enum PMS {
  ezyVet = 'ezyVet',
  RxWorks = 'RxWorks',
  Robovet = 'Robovet',
  Merlin = 'Merlin',
  Teleos = 'Teleos',
  Provet = 'Provet',
  Ascend = 'Ascend',
  VetIT = 'VetIT',
}
